import React, { useContext } from 'react';
import FavouritesMenu from './FavouritesMenu';
import ContentMenu from './ContentMenu';
import AppsMenu from './AppsMenu';
import ViewsMenu from './ViewsMenu';
import WorkspacesMenu from './WorkspacesMenu';
import AccountContext from '../../../../../../contexts/AccountContext';
import CurrentUserContext from '../../../../../../contexts/CurrentUserContext';
import ImpersonatorContext from '../../../../../../contexts/ImpersonatorContext';
import FeatureGate, {
  FEATURE_GATES,
} from '../../../../../../components/FeatureGate';
import InsightsChatNavButton from '../../../Common/InsightsChatNavButton';

const Left = () => {
  const { isTopNavMenusHidden } = useContext(AccountContext);
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const { viewingAppAs } = useContext(ImpersonatorContext);

  if (isTopNavMenusHidden) {
    const isActingAsStaff = isFleetOpsStaff && !viewingAppAs;
    return <>{isActingAsStaff && <ContentMenu />}</>;
  }

  return (
    <>
      <FavouritesMenu />
      <WorkspacesMenu />
      <AppsMenu />
      <ViewsMenu />
      <ContentMenu />
      <FeatureGate featureName={FEATURE_GATES.AI_INSIGHTS_CHAT}>
        <InsightsChatNavButton />
      </FeatureGate>
    </>
  );
};

export default Left;
